import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { IntegrationCard } from "apps/integrations/crm/integration-cards/integration-card";
import useDonorSearchIntegration from "scripts/apps/integrations/crm/utils/use-donor-search-integration";
import donorSearchImage from "../images/donor-search.svg";

export const DonorSearchIntegration = ({ initialData }) => {
  const { exists, state, loading, handleIntegrationClick, handleLogoutClick } = useDonorSearchIntegration({ initialData });

  if (!exists) return null;

  return (
    <CardWrapper>
      <IntegrationCard
        headerTitle="Donor Search"
        state={state}
        loading={loading}
        handleIntegrationClick={handleIntegrationClick}
        handleLogoutClick={handleLogoutClick}
        contentImageHref={donorSearchImage}
        allowDeactivate={true}
        primaryContentText="Enrich constituent profiles with Donor Search wealth screening data."
      />
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  img {
    width: auto;
    max-width: 80px;
    max-height: 60px;
    padding-bottom: 8px;
  }
`;

DonorSearchIntegration.propTypes = {
  initialData: PropTypes.object,
};

DonorSearchIntegration.defaultProps = {
  initialData: null,
};

export default DonorSearchIntegration;
